import React from 'react';
import { Button, Popconfirm, Space, Switch } from 'antd';
import { getNameByUsersKey, getDateFormatted, getBoolean } from './utils';

export const buildColumn = (array) => array.map((item) => {

	if (item === 'createdAt') {
		return {
			title: <b>F. de alta</b>,
			key: 'createdAt',
			render: (record) => (
				<Space>
					{getDateFormatted(record.createdAt)}
				</Space>
			)
		};
	}
	if (item === 'isActive') {
		return {
			title: <b>Tiene acceso</b>,
			key: 'isActive',
			render: (record) => (
				<Space>
					{getBoolean(record.isActive)}
				</Space>
			)
		};
	}
	if (item === 'needsPasswordReset') {
		return {
			title: <b>Cambiar contraseña</b>,
			key: 'needsPasswordReset',
			render: (record) => (
				<Space>
					{getBoolean(record.isActive)}
				</Space>
			)
		};
	}

	if (item === 'actions') {
		return {
			title: <b>Contraseña</b>,
			key: 'action',
			fixed: 'right',
			index: 10,
			render: (record) => (
				<Space size="small">
					<Popconfirm
						title="¿Estás seguro que desea reiniciar la contraseña?"
						onConfirm={record.onResetPassword}
						onCancel={() => { }}
						okText="Si"
						cancelText="No"
					>
						<Button type="danger" ghost size="small"> Reiniciar</Button>

					</Popconfirm>

				</Space>

			)
		};
	}
	if (item === 'edit') {
		return {
			title: <b>Editar</b>,
			key: 'edit',
			fixed: 'right',
			index: 10,
			render: (record) => (
				<Space size="small">
					<Popconfirm
						title="¿Estás seguro que desea editar el usuario?"
						onConfirm={record.onEdit}
						onCancel={() => { }}
						okText="Si"
						cancelText="No"
					>
						<Button type="danger" ghost size="small"> editar</Button>

					</Popconfirm>

				</Space>

			)
		};
	}
	if (item === 'acceso') {
		return {
			title: <b>Acceso</b>,
			key: 'acceso',
			fixed: 'right',
			index: 10,
			render: (record) => (
				<Space>
					<Popconfirm
						title="¿Estás seguro que desea cambiar el estado del usuario?"
						onConfirm={() => {
							if (record.isActive) {
								record.onDelete()
							} else {
								record.onActivate()
							}
						}}
						onCancel={() => { }}
						okText="Si"
						cancelText="No"
					>
						<Switch checkedChildren="Activo" unCheckedChildren="Inactivo" checked={record.isActive}  />
						</Popconfirm>

				</Space>
			)

		}
	}

	return {
		title: getNameByUsersKey(item),
		dataIndex: item
	};
});


export const inspectorsColumn = buildColumn(['lastName', 'name', 'internalIdentifier', 'dni', 'email', 'createdAt', 'needsPasswordReset', 'actions', 'acceso', 'edit']);

export const supervisorsColumn = buildColumn(['lastName', 'name', 'internalIdentifier', 'email', 'createdAt', 'needsPasswordReset', 'actions', 'acceso', 'edit']);

export const adminColumn = buildColumn(['lastName', 'name', 'internalIdentifier', 'email', 'createdAt', 'needsPasswordReset', 'actions', 'acceso', 'edit']);




